export const translations = {
  fr: {
    homepage: {
      title:
        "Cet complément vous permettra de signaler les e-mails de phishing à Elba. Si l'e-mail de phishing est un test Elba, cela augmentera votre score sur le classement Elba !",
      subtitle: 'Utilisez-moi pour taguer les e-mail qui vous paraissent suspects.',
    },
    reportCard: {
      sender: 'Expéditeur',
      subject: 'Sujet',
      reportEmail: "Signaler l'email",
      resultWhenFromElba: {
        title: "Bien joué, c'était un test d'elba !",
        description: 'Merci de votre vigilance.',
      },
      resultWhenNotFromElba: {
        title: "Cet email n'est pas un test d'elba…",
        description: `Merci pour votre aide, le signalement a été transmis à votre équipe informatique.`,
      },
      authentication: {
        title: 'Authentification Outlook requise',
        description:
          'Utilisez une version à jour d’Outlook, reconnectez-vous et terminez les vérifications demandées, puis réessayez. Si une approbation est nécessaire, contactez votre équipe informatique.',
      },
      refused: {
        title: 'Signalement non transmis',
        description:
          'Votre organisation doit terminer la configuration du signalement des emails. Contactez votre équipe informatique.',
      },
      unexpectedError: {
        title: 'Transmission du signalement non confirmée',
        description:
          'Impossible de confirmer que votre signalement a été transmis à votre organisation. Réessayez.',
        try_again: 'Réessayer',
      },
      peekHeader: {
        title: 'Taguez les e-mails',
        description: 'Cliquez sur "afficher"',
      },
    },
  },
  en: {
    homepage: {
      title:
        'This add-in will allow you to report phishing emails to elba, if the phishing email is an elba test, this will increase your score on the elba leaderboard!',
      subtitle: 'Use me to flag suspicious e-mails.',
    },
    reportCard: {
      sender: 'Sender',
      subject: 'Subject',
      reportEmail: 'Report this email',
      resultWhenFromElba: {
        title: 'You rock, it was a test from elba!',
        description: 'Have a nice & safe day.',
      },
      resultWhenNotFromElba: {
        title: 'This email is not a test from elba…',
        description: 'Your report has been sent to your IT team.',
      },
      authentication: {
        title: 'Outlook authentication required',
        description:
          'Use an up-to-date version of Outlook, sign in and complete any required verification, then try again. If approval is required, contact your IT team.',
      },
      refused: {
        title: 'Report not sent',
        description:
          'Your organisation needs to finish email reporting setup. Contact your IT team.',
      },
      unexpectedError: {
        title: 'Report submission not confirmed',
        description: 'We couldn’t confirm that your report reached your organisation. Try again.',
        try_again: 'Try again',
      },
      peekHeader: {
        title: 'Flag e-mails',
        description: 'Click on "view" to start flagging',
      },
    },
  },
} as const;
